// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"522":"0f6102b5","821":"6b4b6fd6","921":"1aea8637","965":"31fd0c87","974":"e14ef107"}[chunkId] + ".chunk.js");